import http from '@/http'

const API_PATH = 'system_manage/'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  async show({ commit }) {
    const tmpURL = http.defaults.baseURL.replace(new RegExp('client/$'), '')
    let result = false
    await http({
      url: tmpURL + API_PATH
    }).then(response => {
      result = response?.data?.data?.attributes?.isMaintenaceMode
    }).catch(error => {
      commit('setHttpError', error, { root: true })
    })
    return result
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
